module.exports = __webpack_public_path__ + "img/tap_and_play.733d940c.svg";